/**
 * @Author: Li, Yu Jia
 * @Date: 2020-03-21 15:14:25
 * @Last Modified by: Li, Yu Jia
 * @Last Modified time: 2020-03-21 15:16:31
 */

import TokenWarning from './TokenWarning';

export default TokenWarning;
